"use client"
import { View, StyleSheet, Image } from "react-native"
import { Surface, IconButton, useTheme } from "react-native-paper"
import { Sun, Moon, LogOut } from "lucide-react"
import { useTheme as useAppTheme } from "../contexts/ThemeContext"
import { useAuth } from "../contexts/AuthContext"
import { useNavigation } from "@react-navigation/native"

// Import the logo from assets
import logoImage from "../../assets/logo.png"

// Update the HeaderProps interface to include showHome prop
interface HeaderProps {
  showLogout?: boolean
  showThemeToggle?: boolean
  showBackButton?: boolean
  showHome?: boolean
}

// Update the Header component to accept and use the showHome prop
export function Header({
  showLogout = true,
  showThemeToggle = true,
  showBackButton = false,
  showHome = false,
}: HeaderProps) {
  const { logout } = useAuth()
  const { toggleTheme, isDarkMode } = useAppTheme()
  const theme = useTheme()
  const navigation = useNavigation()

  return (
    <Surface style={[styles.header, { backgroundColor: theme.colors.elevation.level2 }]} elevation={4}>
      <View style={styles.headerContent}>
        <View style={styles.headerLeft}>
          {showBackButton && (
            <IconButton
              icon="arrow-left"
              size={24}
              onPress={() => navigation.goBack()}
              iconColor={theme.colors.primary}
            />
          )}
          <Image source={logoImage} style={styles.logo} resizeMode="contain" />
        </View>
        <View style={styles.headerRight}>
          {showHome && (
            <IconButton
              icon="home"
              size={24}
              onPress={() => {
                // Reset navigation to go back to root screen
                navigation.reset({
                  index: 0,
                  routes: [{ name: 'AllProjectsDashboard' as never }],
                })
              }}
              iconColor={theme.colors.primary}
            />
          )}
          {showThemeToggle && (
            <IconButton
              icon={() =>
                isDarkMode ? (
                  <Sun size={20} color={theme.colors.onSurface} />
                ) : (
                  <Moon size={20} color={theme.colors.onSurface} />
                )
              }
              onPress={toggleTheme}
            />
          )}
          {showLogout && <IconButton icon={() => <LogOut size={20} color={theme.colors.error} />} onPress={logout} />}
        </View>
      </View>
    </Surface>
  )
}

const styles = StyleSheet.create({
  header: {
    height: 48,
    justifyContent: "center",
  },
  headerContent: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 16,
  },
  headerLeft: {
    flexDirection: "row",
    alignItems: "center",
    height: "100%",
    gap: 12,
  },
  headerRight: {
    flexDirection: "row",
    alignItems: "center",
  },
  logo: {
    height: 30,
    width: 120,
    marginRight: 16,
  },
})

